<template>
    <div class="Details">
    <section>
        <div class="columns">
          <div class="column">
            <div class="box">
                <h4 class="title is-6">Alarms</h4>
                <p>
                    <b-tag type="is-success">Ok</b-tag> Inference API is operational (<a href="https://status.metatext.io/" target="_blank">see status page</a>)<br>
                    <b-tag type="is-success">Ok</b-tag> No alarms <br>
                </p>
            </div>
            

          </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="box">
                  <h2 class="title is-6" v-if="monitoring">
                      Response time <span v-if="avgLatency">(Average {{ avgLatency }}ms)</span>
                  <small align="is-right"><br>
                    (last 30 days)
                  </small>
                  </h2>
                  
                  <div>

                  <apexchart type="line" height="220" :options="optionLatency" :series="seriesLatency" v-if="monitoring"></apexchart>
                  </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <!--div class="column">
                <h2 class="title is-6">
                    Number of requests (Last 4 weeks)
                </h2>
                <div>
                <apexchart type="bar" height="320" :options="options" :series="series"></apexchart>
                </div>
            
            </div-->
            <div class="column">
              <div class="box">
                <h2 class="title is-6">
                    Requests
                    <small align="is-right"><br>
                    (last 30 days)
                  </small>
                </h2>
                  <div>
                  <apexchart type="line" height="200" :options="optionRequest" :series="seriesRequest"></apexchart>
                  </div>
              </div>
            </div>
        </div>
        
        
        
        <div class="column" v-if="tableData" >
                    <h4 class="title is-6">Requests history</h4>
                    
                    <b-table 
                    :data="tableData" 
                    :columns="selectCols(dataset.cols)"
                    :default-sort="tableSort"
                    :per-page="30"
                    paginated>
                    </b-table>
                </div>
                <div class="column" v-else>
                    <h4 class="title is-6">Request history</h4>
                    <b-skeleton width="100%" :animated="animated"></b-skeleton>
                    <b-skeleton width="100%" :animated="animated"></b-skeleton>
                    <b-skeleton width="100%" :animated="animated"></b-skeleton>

                </div>

    </section>

    </div>
</template>
<script>

import DataFrame from 'dataframe-js';

   export default {
     props: ["model","datasetId", "training"],
     name: "Monitoring",
data: function() {
    return {
      animated: true,
      tableData: false,
      tableSort: ['label', 'text'],
      options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          //categories: ["Jan", "Fev", "Mar", "Apr", "May", "Jun", "Jul", "Ago"]
        }
      },
      optionsDrift: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: ["1", "2", "3", "4", "5", "6", "7", "8"]
        }
      },
      seriesDrift: [{
        name: 'Delta avg',
        data: [0, 0, 0, 0, 0, 0, 0, 0]
      // },{
      //   name: 'Production',
      //   data: [0, 0, 0, 1, 0, -2, 1, -1]
      // }],
      }],
      series: [{
        name: '# requests',
        data: [0, 0, 0, 0, 0, 0, 0, 0]
      }]  
    }
  },
  methods: {
         selectCols(data_cols){
            var new_cols = data_cols
            
            Object.keys(new_cols).forEach(key => {
                
                if (new_cols[key].label !== 'label' && new_cols[key].label !== 'text') delete new_cols[key]
                else if (new_cols[key].label === 'label') new_cols[key].label = 'predicted'
            });

            return new_cols
         },
         downloadJson(datasetId){
             var filepath = `datasets/${datasetId}/${this.dataset.jsonfilename}`
             
             const objectRef=firebase.storage().ref(filepath)

             objectRef.getDownloadURL().then((url) => {
                
                DataFrame.fromJSON(url).then(df => {
                    var label_col = this.dataset.label
                    var text_col = this.dataset.text
                    
                    this.tableData = df.select(text_col, label_col).sample(0.01).toCollection().slice(0,10);

                })
             })


             


         },
         plot_latency(metrics){

           let latencyq50 = new Array()
           let latencyq90 = new Array()
           let dates = new Array()
           
           for (let i=0; i<metrics.length; i++){

              latencyq50.push(
                metrics[i]["latency_q50"].toFixed(2)
              )
              latencyq90.push(
                metrics[i]["latency_q90"].toFixed(2)
              )

              dates.push(
                metrics[i]["date"]
              )
           }

           let options = {
              chart: {
                id: 'response-time-plot'
              },
              xaxis: {
                categories: dates.slice(-30)
              }
            }

            let series = [{
             name: "latency p50",
             data: latencyq50.slice(-30)
           },
           {
             name: "latency p90",
             data: latencyq90.slice(-30)
           }]

           return [series, options, latencyq50.map(Number)]

         },
         plot_usage(metrics){

           let count = new Array()
           let dates = new Array()
           
           for (let i=0; i<metrics.length; i++){

              count.push(
                metrics[i]["requestPayload_count"].toFixed(2)
              )

              dates.push(
                metrics[i]["date"]
              )
           }

           let options = {
              chart: {
                id: 'request-count-plot'
              },
              xaxis: {
                categories: dates.slice(-30)
              }
            }

            let series = [{
             name: "request count",
             data: count.slice(-30)
           }]

           return [series, options, count.map(Number)]

         }
     },
     computed: {
       monitoring() {
         let m = this.$store.state.modelMonitoring;
         
         let latencyPlot = this.plot_latency(m)
         
         this.seriesLatency = latencyPlot[0]
         this.optionLatency = latencyPlot[1]
         
         this.avgLatency = latencyPlot[2][0]

         let requestPlot = this.plot_usage(m)
         this.seriesRequest = requestPlot[0]
         this.optionRequest = requestPlot[1]
         

         return m
       },
       dataset() {
         return this.$store.state.dataset;
       },
     },
     created() {
       

       // this.$store.dispatch("currentDataset", this.datasetId);

       this.$store.dispatch("currentModelMonitoring", this.model.id);
       
       
      //  if (this.dataset){
      //     this.downloadJson(this.datasetId)
      //  }
       
       // console.log(this.pageId)
       //this.$store.dispatch("displayModelDetails", this.boardId);
       
     }
   };
</script>